import {
    ComponentType, useEffect,
} from 'react';
import { IndexRoutes } from './routes'
import { AlertDialog, CustomSnackProvider } from "@sicarx/sxe-components"
import { RootStoreState,useStore, EcommerceInterface, secureSessionStorage} from '@sicarx/sxe-api';
import { ErrorBoundary, FallbackProps, ErrorBoundaryProps } from 'react-error-boundary';
import { Box, Button, Stack, Typography } from '@mui/material';
import { ErrorRoundOutlineSvg, TERRORCODE, TGLOBAL, TNamespace } from '@sicarx/sxe-core';
import { useTranslation } from 'react-i18next';
function App() {

    const setStore = useStore((store: RootStoreState) => store.setStore);
    const store = useStore((store: RootStoreState) => store.store);

    const loadStore = async () => {
        try {
            const persisted = secureSessionStorage.getItem("store-storage") as { state?: { store?: EcommerceInterface } } | null;
            if (persisted?.state?.store) {
                setStore(persisted.state.store);
            } else {
                console.log("no data")
            }
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        loadStore()
    }, [])


    const handleError: ErrorBoundaryProps["onError"] = (error, info) => {
        console.log(error)
        console.log(info)
    }

    const handleReset: ErrorBoundaryProps["onReset"] = (details) => {
        console.log(details)
    }

    return (
        <ErrorBoundary FallbackComponent={FallbackComponent} onError={handleError} onReset={handleReset}>
            <CustomSnackProvider>
                {store || window.location.hostname.startsWith("pay.") ?
                    <IndexRoutes />
                    : null}
                <AlertDialog />
            </CustomSnackProvider>
        </ErrorBoundary>
    )
}

const FallbackComponent: ComponentType<FallbackProps> = ({ error, resetErrorBoundary }) => {
    const { t } = useTranslation([TNamespace.ERRORCODE, TNamespace.GLOBAL]);
    return (
        <Stack direction={"column"} spacing={2} alignItems="center" justifyContent="center" sx={{ height: '100%', width: '100%', backgroundColor: "#f5f5f8" }}>
            <Box sx={{
                backgroundColor: "transparent",
                lineHeight: 0,
                borderRadius: "50%",
                height: "130px",
                width: "130px"
            }}
            >
                <ErrorRoundOutlineSvg color="error" sx={{ height: "100%", width: "100%" }} />
            </Box>
            <Typography>{t(TERRORCODE.CREDITPAYMENT_0, { ns: TNamespace.ERRORCODE })}</Typography>
            <Button sx={{ boxShadow: "none", borderRadius: 1 }} variant='contained' onClick={resetErrorBoundary}>{t(TGLOBAL.TRY_AGAIN, { ns: TNamespace.GLOBAL })}</Button>
        </Stack >
    );
}

export default App;